<validation-errors></validation-errors>

<style>
    .my-drop-zone { border: dashed 1px #9AA3A8; padding: 25px; margin-top: 10px; background-color: white; text-align: center;}
    .nv-file-over { border: dashed 1px #00355E; background-color: lightgray; } /* Default class applied to drop zones on over */
    .another-file-over-class { border: dotted 3px green; }
    html, body { height: 100%; }
</style>
  <modal-component #guestError
                   (accept)="modalContinueClick($event)"
                   [title]="getModalTitle()"
                   [data]="{
                    resizeOrClose:'close'}">
                    <p>{{getModalBody()}}</p>
  </modal-component>
  <div>
    <div ng2FileDrop
            [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
            (fileOver)="fileOverBase($event)"
            [uploader]="uploader"
            class="well my-drop-zone">
        <label for="files" class="custom-file-upload">Upload File</label>
        <input id="files" type="file" ng2FileSelect [uploader]="uploader" (change)="onChange($event);"  />
        <label style="font-weight:normal">&nbsp; or Drag & Drop File to be validated here and the results will be displayed below</label>
    </div>
</div>

<div class="validation-progress">
  <div>
    <label for="upler" id="validation-label">Validation progress:</label>
    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar" [ngStyle]="{ 'width': getUploaderProgress() + '%' }">{{getUploaderProgress()}}%</div>
    </div>
    <br><br>
  </div>
</div>

<div class="guest-validation-results">
  <table aria-describedby="Active Session Table" class="table" id="activeSessionTable">
    <colgroup>
      <col *ngFor="let percent of columnWidths"
           [ngStyle]="{ 'width': percent }">
    </colgroup>
    <thead>
    <tr>
      <th id="session-header" *ngFor="let name of headers">{{name}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let validationResult of guestValidationResults">
      <td class="truncate" [title]="validationResult.filename">{{validationResult.filename}}</td>
      <td class="truncate" [title]="validationResult.reportedStatus">{{validationResult.reportedStatus}}</td>
      <td class="nowrap"   [title]="validationResult.sampleCount">{{validationResult.sampleCount}}</td>
      <td class="truncate" [title]="validationResult.validationMessage">{{validationResult.validationMessage}}</td>
      <td class="nowrap"   id="hasErrors" (click)='showGuestValidationErrors(validationResult)' *ngIf="validationResult.validationErrors !== null">View Errors</td>
      <td class="nowrap"   *ngIf="validationResult.validationErrors === null">None Available</td>
    </tr>
    </tbody>
  </table>
</div>
